class InitialSettingsService {
  private static serviceInstance: InitialSettingsService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public tlaBodyStyleQueryString(): string[] | null {
    let tlaBodyStyles: string[] | null = null;
    try {
      const urlParams = new URLSearchParams(window.location.search);
      tlaBodyStyles = urlParams.getAll('tlaBodyStyles');
    } catch {
      tlaBodyStyles = null;
    }
    return tlaBodyStyles;
  }

  public tlaFuelTypeQueryString(): string[] | null {
    let tlaFuelTypes: string[] | null = null;
    try {
      const urlParams = new URLSearchParams(window.location.search);
      tlaFuelTypes = urlParams.getAll('tlaFuelTypes');
    } catch {
      tlaFuelTypes = null;
    }
    return tlaFuelTypes;
  }

  public restrictionQueryString(): string | null {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('restriction');
    } catch {
      return null;
    }
  }

  public hasCorrelationId() : boolean {
    return !!window.localStorage.getItem('correlationId');
  }

  public getOrGenerateCorrelationId(): string {
    let correlationId = window.localStorage.getItem('correlationId');

    if (!correlationId) {
      correlationId = InitialSettingsService.createNewGuid();
      window.localStorage.setItem('correlationId', correlationId);
    }

    return correlationId;
  }

  private static createNewGuid(): string {
    // Taken from https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid#answer-2117523
    let d = new Date().getTime();
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let r = Math.random() * 16;
      if (d > 0) {
        // eslint-disable-next-line no-bitwise
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        // eslint-disable-next-line no-bitwise
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      // eslint-disable-next-line no-bitwise,no-mixed-operators
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const initialSettingsService = InitialSettingsService.instance;
